import React, { useState } from 'react'
import styles from './index.less'
import { ArrowRightOutlined, CheckSquareOutlined, } from '@ant-design/icons';
import classNames from 'classnames';
import IconFont from 'src/components/IconFont'
import { withRouter } from 'react-router-dom'

function index(props) {
    const [activeIndex, setActiveIndex] = useState(-1)
    const [dataArr, setDataArr] = useState([{
        text: '通用识别',
        bg_img: require('assets/images/home/通用背景.png'),
        icon_img: require('assets/images/home/通用图标.png'),
        icon_type: 'icon-pingtai_mokuai',
        details_desc: 'aaaaaaaaaaaaaaanbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb',
        dataLi: [
            {
                li_Content: "实时人流量监控",
            },
            {
                li_Content: "车牌识别",
            },
            {
                li_Content: "动物闯入",
            },
            {
                li_Content: "违停监控",
            },
        ]
    }, {
        text: '物体检测',
        bg_img: require('assets/images/home/物体检测背景.png'),
        icon_img: require('assets/images/home/物体监测.png'),
        icon_type: 'icon-wutijiance',
        details_desc: 'aaaaaaaaaaaaaaa',
        dataLi: [
            {
                li_Content: "烟雾检测",
            },
            {
                li_Content: "口罩佩戴检测",
            },
            {
                li_Content: "手机识别监控",
            },
            {
                li_Content: "小广告检测",
            },

        ]
    }, {
        text: '工地监控',
        bg_img: require('assets/images/home/工地监控背景.png'),
        icon_img: require('assets/images/home/工地监控.png'),
        icon_type: 'icon-gongdijiankong',
        details_desc: 'aaaaaaaaaaaaaaa',
        dataLi: [
            {
                li_Content: "施工未戴安全帽监控",
            },
            {
                li_Content: "斗臂车检测",
            },
            {
                li_Content: "防护用具识别",
            },
        ]
    }, {
        text: '电力特种',
        bg_img: require('assets/images/home/电力特种背景.png'),
        icon_img: require('assets/images/home/电力 特种.png'),
        icon_type: 'icon-dianli',
        details_desc: 'aaaaaaaaaaaaaaa',
        dataLi: [
            {
                li_Content: "红外摄像头测温识别",
            },
            {
                li_Content: "电力仪表识别",
            },
            {
                li_Content: "非法闯入监控",
            },

        ]
    }, {
        text: '机房监控',
        bg_img: require('assets/images/home/机房监控背景.png'),
        icon_img: require('assets/images/home/机房去监控.png'),
        icon_type: 'icon-jifang',
        details_desc: 'aaaaaaaaaaaaaaa',
        dataLi: [1, 2, 3,],
        dataLi: [
            {
                li_Content: "门禁出入监控",
            },
            {
                li_Content: "仪表监控",
            },
        ]
    }, {
        text: '区域监控',
        bg_img: require('assets/images/home/174.png'),
        icon_img: require('assets/images/home/通用图标.png'),
        icon_type: 'icon-shipinjiankong',
        details_desc: 'aaaaaaaaaaaaaaa'
        ,
        dataLi: [
            {
                li_Content: "电瓶车禁入禁放监控",
            },
            {
                li_Content: "车辆闯入监控",
            },
            {
                li_Content: "人员拉扯检测",
            },
            {
                li_Content: "人群密集统计",
            },

        ]
    }, {
        text: '工业生产',
        bg_img: require('assets/images/home/1742.png'),
        icon_img: require('assets/images/home/通用图标.png'),
        icon_type: 'icon-shengchan',
        details_desc: 'aaaaaaaaaaaaaaa',
        dataLi: [
            {
                li_Content: "供电线路防外破项目",
            },
            {
                li_Content: "灭火器识别",
            },
            {
                li_Content: "煤气罐禁入识别",
            },

        ]

    }, {
        text: '地理空间',
        bg_img: require('assets/images/home/地理空间_bg.png'),
        icon_img: require('assets/images/home/通用图标.png'),
        icon_type: 'icon-map',
        details_desc: 'aaaaaaaaaaaaaaa',
        dataLi: [
            {
                li_Content: "铁路监控",
            },
            {
                li_Content: "无人岛开发监控",
            },
        ]
    }])



    return (
        <div className={styles.container}>
            <div className={styles.item}>
                <img className={styles.bg_img} src={require('assets/images/home/industry_solution.png')} alt="" />
                <div className={styles.title}>
                    <span className={styles['title-text']}>行业解决方案</span>
                    <span className={styles['title-right']}></span>
                </div>
                <div className={styles.subTitle}>图像算法精准成熟，可以运用于各种场景</div>
                <img className={styles.point} src={require('assets/images/home/背景点点-.png')} alt="" />
                <div className={classNames(styles.more, 'mt-20')}>
                    <ReactRouter.Link to='/algorithmList' className='mr-50'><span className='mr-10'>查看更多方案   </span> <ArrowRightOutlined /></ReactRouter.Link>

                </div>
            </div>
            <div className={styles.item}>
                {
                    dataArr.map((item, index) => (
                        <div className={styles.item_box_container}>
                            <div className={styles.item_box} onMouseEnter={() => setActiveIndex(index)} onMouseLeave={() => setActiveIndex(-1)}>
                                {
                                    <div className={classNames(styles.details_desc, activeIndex !== index && styles.details_desc_hidden)} onClick={() => { props.history.push('/algorithmList') }}>
                                        {/* {item.details_desc} */}
                                        <div className={styles.details_back}>
                                            <div className={styles.details_top}>
                                                <div className={styles.details_icon}>
                                                    <IconFont type={item.icon_type} className={styles.iconfont} />
                                                </div>
                                                <div className={styles.details_font}>
                                                    {item.text}
                                                </div>
                                            </div>
                                            {
                                                item.dataLi?.map((ii) => (
                                                    <div className={styles.details_li}>
                                                        <div className={styles.li_icon}>
                                                            <CheckSquareOutlined />
                                                        </div>
                                                        <div className={styles.li_Content}>
                                                            {ii.li_Content}
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    </div>
                                }
                                {
                                    <div className={classNames(styles.simple, activeIndex == index && styles.simple_hideen)}>
                                        <img className={styles.bg_img} src={item.bg_img} alt="" />
                                        <div className={styles.content}>
                                            <IconFont type={item.icon_type} className={styles.iconfont} />
                                            <div className={styles.text}>{item.text}</div>
                                        </div>
                                    </div>

                                }
                            </div>
                        </div>

                    ))
                }
                {/* <div onMouseEnter={() => setActiveIndex(0)}>
                    {
                        activeIndex == 0 && <div>111</div>
                    }
                    {
                        activeIndex !== 0 &&
                        <img src={require('assets/images/home/通用背景.png')} alt="" />

                    }
                </div>
                <div onMouseEnter={() => setActiveIndex(1)}>
                    {
                        activeIndex == 1 && <div>111</div>
                    }
                    {
                        activeIndex !== 1 &&
                        <img src={require('assets/images/home/test.jpg')} alt="" />

                    }</div>
                <div onMouseEnter={() => setActiveIndex(2)}><img src={require('assets/images/home/test.jpg')} alt="" />

                </div>
                <div onMouseEnter={() => setActiveIndex(3)}><img src={require('assets/images/home/test.jpg')} alt="" /></div>
                <div onMouseEnter={() => setActiveIndex(4)}><img src={require('assets/images/home/test.jpg')} alt="" /></div>
                <div onMouseEnter={() => setActiveIndex(5)}><img src={require('assets/images/home/test.jpg')} alt="" /></div>
                <div onMouseEnter={() => setActiveIndex(6)}><img src={require('assets/images/home/test.jpg')} alt="" /></div>
                <div onMouseEnter={() => setActiveIndex(7)}><img src={require('assets/images/home/test.jpg')} alt="" /></div> */}
            </div>
        </div>
    )
}

export default withRouter(index)